export default __webpack_public_path__ + "static/media/937.e31a7be5.png";